












  import { Component, Prop, Vue } from 'vue-property-decorator';

  import { SecondLevelOptionModel } from '@/shared/models/secondLevelOption.model';

  @Component({
      components: {
      },
  })
  export default class SecondLevelOptionComponent extends Vue {
      // PROPS
      @Prop() private secondLevelOption!: SecondLevelOptionModel;
      @Prop( { default: false } ) private parentSelectorDisabled!: boolean;

      // DATA
      private toBeShowedDisabledReason: boolean = false;

      // COMPUTED
      get labelToShow() {
          return ( this.toBeShowedDisabledReason ) ?
              this.secondLevelOption.disabledLabel :
              this.secondLevelOption.label;
      }

      // METHODS
      private checkOptionDisabled() {
          return this.parentSelectorDisabled || this.secondLevelOption.disabled;
      }

      private showDisabledReason() {
          if ( this.secondLevelOption.disabled && this.secondLevelOption.disabledLabel ) {
              this.toBeShowedDisabledReason = true;
          }
      }

      private hideDisabledReason() {
          if ( this.secondLevelOption.disabled && this.secondLevelOption.disabledLabel ) {
              this.toBeShowedDisabledReason = false;
          }
      }

      private emitClick() {
          this.$emit( 'emitClick', this.secondLevelOption );
      }
}
